import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useAuth } from '../../Constant/Auth';
import '../parentTables.css';

import {
  getMyPayments,
  getErrorMessage
} from '../../api/api';

const ParentPaymentList = () => {
  const { user } = useAuth();

  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPayments = async () => {
    try {
      if (!user?.id) return;

      setLoading(true);

      // Self-scoped: the backend resolves "my" payments from the verified
      // login, never from a client-supplied id — so this only ever returns
      // this parent's own payment history, never the whole library's.
      const data = await getMyPayments();

      setPayments(data || []);
    } catch (error) {
      console.error('Parent payments error:', error);
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const getStatusBadge = (status) => {
    if (status === 'success') return 'bg-success';
    if (status === 'pending') return 'bg-warning text-dark';
    if (status === 'failed') return 'bg-danger';
    return 'bg-secondary';
  };

  return (
    <div className="container-fluid mt-3 pt-page">
      <div className="pt-page-header">
        <div className="pt-page-header__left">
          <span className="pt-page-header__icon">
            <i className="fas fa-credit-card" />
          </span>
          <div>
            <h3 className="pt-page-header__title">My Payments</h3>
            <div className="pt-page-header__subtitle">View payment history</div>
          </div>
        </div>
      </div>



      <div className="card shadow-sm mt-3 table-full-card">
        <div className="card-body">
          {loading ? (
            <div className="text-center py-4">Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Payment Type</th>
                    <th>Amount</th>
                    <th>Mode</th>
                    <th>Transaction Ref</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {payments.length > 0 ? (
                    payments.map((payment, index) => (
                      <tr key={payment.id}>
                        <td>{index + 1}</td>
                        <td>{payment.payment_type || '-'}</td>
                        <td>₹ {payment.amount || 0}</td>
                        <td>{payment.payment_mode || '-'}</td>
                        <td>{payment.transaction_ref || '-'}</td>
                        <td>
                          <span className={`badge ${getStatusBadge(payment.payment_status)}`}>
                            {payment.payment_status || '-'}
                          </span>
                        </td>
                        <td>
                          {payment.created_at ? String(payment.created_at).slice(0, 10) : '-'}
                        </td>
                        <td>{payment.remarks || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-4">
                        No payments found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParentPaymentList;